module.exports = __webpack_public_path__ + "img/Signin.91da8b80.png";